import React from 'react'
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { generateEmailOTP, verifyEmailOTP, emailResendOTP,
  generateMobileOTP,verifyMobileOTP,mobileResendOTP,
   login,verifyGmail,verifyGoogleLogin, getCustomerSyncAPI, createV2CustomerUnifiedAPI } from '../http-calls';



export const useCustomerSync = () => {

  return useQuery(
    `customerSync`,
    () => getCustomerSyncAPI(),
  
    {
      onSuccess:(data)=>{
        console.log(">>>>>>",data)

      },
      enabled: false,
    }
  );
  // return useQuery('customerSync', () => getCustomerSyncAPI(), { enabled: false });
}


export const CreateV2Customer = (data) => {
  const queryClient = useQueryClient();
  return useMutation(createV2CustomerUnifiedAPI, {
     onSuccess: (data) => {
       const message = 'success'
     },
     onError: (err) => {},
     onSettled: () => {
       queryClient.invalidateQueries('created');
     },
 })}

export const GenerateEmailOTP = (data) => {
 const queryClient = useQueryClient();
 return useMutation(generateEmailOTP, {
    onSuccess: (data) => {
      const message = 'success'
    },
    onError: (err) => {},
    onSettled: () => {
      queryClient.invalidateQueries('created');
    },
})}

export const VerifyEmailOTP = (data) => {
  const queryClient = useQueryClient();
  return useMutation(verifyEmailOTP, {
     onSuccess: (data) => {
       const message = 'success';
     },
     onError: (err) => {},
     onSettled: () => {
       queryClient.invalidateQueries('created');
     },
 })}

 export const ResendEmailOTP = (data) => {
  const queryClient = useQueryClient();
  return useMutation(emailResendOTP, {
     onSuccess: (data) => {
       const message = 'success';
     },
     onError: (err) => {},
     onSettled: () => {
       queryClient.invalidateQueries('created');
     },
 })}

 export const GenerateMobileOTP = (data) => {
  const queryClient = useQueryClient();
  return useMutation(generateMobileOTP, {
     onSuccess: (data) => {
       const message = 'success'
     },
     onError: (err) => {},
     onSettled: () => {
       queryClient.invalidateQueries('created');
     },
 })}
 
 export const VerifyMobileOTP = (data) => {
   const queryClient = useQueryClient();
   return useMutation(verifyMobileOTP, {
      onSuccess: (data) => {
        const message = 'success';
      },
      onError: (err) => {},
      onSettled: () => {
        queryClient.invalidateQueries('created');
      },
  })}
 
  export const ResendMobileOTP = (data) => {
   const queryClient = useQueryClient();
   return useMutation(mobileResendOTP, {
      onSuccess: (data) => {
        const message = 'success';
      },
      onError: (err) => {},
      onSettled: () => {
        queryClient.invalidateQueries('created');
      },
  })}

 export const Login = (data) => {
  const queryClient = useQueryClient();
  return useMutation(login, {
     onSuccess: (data) => {
       const message = 'success';
     },
     onError: (err) => {},
     onSettled: () => {
       queryClient.invalidateQueries('created');
     },
 })}

 export const VerifyGmail = (data) => {
  const queryClient = useQueryClient();
  return useMutation(verifyGmail, {
     onSuccess: (data) => {
       const message = 'success';
     },
     onError: (err) => {},
     onSettled: () => {
       queryClient.invalidateQueries('created');
     },
 })}

 export const VerifyGoogleLogin = (data) => {
  const queryClient = useQueryClient();
  return useMutation(verifyGoogleLogin, {
     onSuccess: (data) => {
       const message = 'success';
     },
     onError: (err) => {},
     onSettled: () => {
       queryClient.invalidateQueries('created');
     },
 })}
 

// export const fetchPreSingedUrl = (data) => {
//   return useQuery('pre_singed_url',  () => getPreSingedUrlApi(data), { enabled: false });
// }

// export const useEsignQuery = () => {
//   return useQuery('esignData', () => getEsignDetails(), { enabled: false });
// };

